import {
  useAuth,
  useCurrentUser,
  useOrganization,
  useTeam,
} from "@hooks";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { EmptyState } from "./EmptyState";
import FullScreenLoading from "../../common/loading/FullScreenLoading";
import OrganizationPage from "../../organization";

const TeamsManagementPage = () => {
  // Hooks
  const { orgUuid, isOrgAdmin, isLoadingOrganization } =
    useOrganization();
  const { loading, error } = useAuth();

  const { userTeams, refreshUserTeams } = useTeam();

  const navigate = useNavigate();
  const { data: currentUser, loading: currentUserLoading } =
    useCurrentUser();

  const [firstTeamCreation, setFirstTeamCreation] = useState(
    userTeams?.length === 0,
  );

  // Latch: once we detect no teams, keep showing the empty/creation state
  // even after a team is created (prevents UI flip mid-creation).
  // State-during-render is React's recommended pattern for this.
  if (!firstTeamCreation && userTeams?.length === 0) {
    setFirstTeamCreation(true);
  }

  // If the user only has one team and they are not an org admin, redirect them
  useEffect(() => {
    if (isLoadingOrganization) return;

    if (userTeams?.length === 1 && !isOrgAdmin) {
      navigate(`/teams/${userTeams[0].uuid}`);
    }
  }, [userTeams, isOrgAdmin, isLoadingOrganization, navigate]);

  if (currentUserLoading || loading) {
    return (
      <FullScreenLoading
        loadingTrigger={currentUserLoading || loading}
      />
    );
  }

  // Show empty state when the latch is set (see firstTeamCreation above)
  if (firstTeamCreation) {
    return (
      <EmptyState
        orgUuid={orgUuid}
        refetch={refreshUserTeams}
        currentUser={currentUser}
      />
    );
  }

  return (
    <OrganizationPage
      refetchTeams={refreshUserTeams}
      loadingTeams={loading}
      userTeams={userTeams}
      userTeamsError={error}
    />
  );
};

export default TeamsManagementPage;
